<template>
  <div>
    <el-container class="my-body">
      <el-header class="my-header" style="height: 55px">
        <myHeader></myHeader>
      </el-header>
      <el-container>
        <el-aside class="my-aside">
          <myAside></myAside>
        </el-aside>
        <el-main class="my-main">
          <div :class="[isHome?'':'content']">
            <div class="content-view" >
              <keep-alive>
                <router-view v-if="!$route.meta.unKeepAlive"></router-view>
              </keep-alive>
              <router-view v-if="$route.meta.unKeepAlive"></router-view>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import myHeader from "../components/myHeader";
import myAside from "../components/myAside";
import topBreadcrumb from "../components/topBreadcrumb";
export default {
  name: "index",
  data(){
    return{
      isHome:false
    }

  },
  components: {
    myHeader,
    myAside,
    topBreadcrumb,
  },
  created() {
    if(this.$route.path=='/home'){this.isHome = true}else{
      this.isHome = false
    }
  },
  watch:{
    $route(to,from){
      // console.log(to);
      if(to.path=='/home'){this.isHome = true}else{
        this.isHome = false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
.my-body {
  width: 100%;
  height: 100vh;
  //overflow: hidden;
}
.my-header {
  padding: 0;
  width: 100%;
  height: 55px;
  background: url("/static/header-bg.png");
  //background-size: 100% 100%;
}
.my-main {
  background: url("/static/con_bg.png");
  background-size: cover;
  //padding: 0;
  height: auto;
  min-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.my-aside {
  width: 220px !important;
  height: calc(100vh - 55px);
  background: #ffffff;
}
.el-container {
  height: calc(100vh - 55px);
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue